import { Button, Modal } from 'antd';

// `loading` spins the confirm button and locks the modal open: the request is
// already on its way, so "cancel" could only hide it, not stop it.
const ConfirmModal = ({ open, onOk, onCancel, textComponent, confirmBtnProps, confirmBtnTitle, loading = false }) => {

  return (
    <Modal
      title={'Potrdi'}
      open={open}
      onCancel={onCancel}
      closable={!loading}
      maskClosable={!loading}
      keyboard={!loading}
      footer={[
        <Button key="cancel" onClick={onCancel} disabled={loading}>Prekliči</Button>,
        <Button key="confirm" type="primary" onClick={() => onOk()} loading={loading} {...confirmBtnProps} >{confirmBtnTitle}</Button>
      ]}
    >
        {textComponent}
    </Modal>
  );
};

export default ConfirmModal;
